window.PerformanceStatsAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("LPMStatsServer"));

    self.getBrandSales = function (brandId, salesParams) {
        var deferred = $q.defer();
        var params = {
            types: salesParams.types,
            start_date: salesParams.startDate.format('YYYY-MM-DD'),
            end_date: salesParams.endDate.format('YYYY-MM-DD'),
            mode: salesParams.mode
        };

        _protected.request('brands/' + brandId + '/stats/sales/types', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandStats = function(brandId, mode, fromDate, toDate, relativeToNow, filterBy){
        var deferred = $q.defer();
        var params = {};
        params.relative_to_now = !!relativeToNow;
        params.mode = mode;
        params.filter_by = filterBy;
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;

        _protected.request('brands/' + brandId + '/stats/filtered', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTopItemsOfSales = function(brandId, date){
        var deferred = $q.defer();
        var params = {};
        params.date = date;
        _protected.request('brands/' + brandId + '/stats/sales/items', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandEmployeesStats = function(brandId, date){
        var deferred = $q.defer();
        var params = {};
        params.date = date;
        _protected.request('brands/' + brandId + '/stats/sales/employees', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandsRevenueCentersActual = function(brandId, from_date, to_date, relative_to_now){
        var deferred = $q.defer();

        var params = {};

        if (from_date) {
            params.from_date = from_date;
        }

        params.to_date =  to_date || from_date;
        params.relative_to_now = relative_to_now || false;

        _protected.request('brands/' + brandId + '/revenue_centers/stats/actual', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandsRevenueCentersForecast = function(brandId, from_date, to_date, relative_to_now){
        var deferred = $q.defer();

        var params = {};

        if (from_date) {
            params.from_date = from_date;
        }


        params.to_date =  to_date || from_date;
        params.relative_to_now = relative_to_now || false;

        _protected.request('brands/' + brandId + '/revenue_centers/stats/forecast', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.status_code == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getForecastedBrandStats = function(brandId, fromDate, toDate, relativeToNow, mode, filterBy){
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {};
        params.relative_to_now = !!relativeToNow;
        params.from_date = fromDate;
        params.to_date = toDate || fromDate;

        if (filterBy) {
            params.filter_by = filterBy;
        }

        if (mode) {
            params.mode = mode;
        }

        _protected.request('brands/' + brandId + '/stats/forecast', 'GET', params).then(function (data) {
            if (data && data.data && data.data.data && data.data.status_code == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandForecastWeeks = function (brandId, fromDate, toDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {};

        if (fromDate) {
            params['from_date'] = fromDate.format("YYYY-MM-DD");
        }

        if (toDate) {
            params['to_date'] = toDate.format("YYYY-MM-DD");
        }


        _protected.request('brands/' + brandId + '/stats/forecast/weeks', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.data.data && data.status == 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.addBrandSalesForecast = function (brandId, forecastedStats) {
        var deferred = $q.defer();

        var params = {};

        if (!Array.isArray(forecastedStats) || !forecastedStats) {
            throw 'We need forecasted_stats send on the params';
        }

        params.forecasted_stats = forecastedStats;

        _protected.request('brands/' + brandId + '/stats/forecast', 'PUT', params)
            .then(function (data) {
            if (data && data.data && data.data.data && data.status == 200) {
                deferred.resolve(data.data.data);
            } else {
                deferred.reject(data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getBrandWeeksHistoricalData = function (brandId, fromDate, toDate) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            from_date: fromDate.format('YYYY-MM-DD'),
            to_date: toDate.format('YYYY-MM-DD')
        };

        _protected.request('brands/' + brandId + '/stats/weeks', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getSignedUrl = function (brandId, fileName) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            filename: fileName
        };

        _protected.request('brands/' + brandId + '/stats/presigned_url', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.resetAppliedAdjustmentsAndReplaces = function (brandId, startDate) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var startDate = moment(startDate).format("YYYY-MM-DD");

        var params = {
            start_week_date: startDate
        };

        _protected.request('brands/' + brandId + '/stats/forecast/reset', 'PUT', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.replaceSalesForecast = function (brandId, destDate, srcBrand, srcDate, type) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }


        var params = {
            'source': {
                'brand_id': srcBrand,
                'date': srcDate
            },
            'destination': {
                'brand_id': brandId,
                'date': destDate
            },
            'type': type
        };

        _protected.request('brands/' + brandId + '/stats/forecast/replace', 'PUT', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.checkMismatchedForecastedSales = function(brandId, templateId, toDate){
        var deferred = $q.defer();

        var params = {
            template_id: templateId,
            destination_week_start_date: toDate
        };

        _protected.request('brands/' + brandId + '/forecast/templates/load/check', 'GET', params)
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateActualSalesStat = function (brandId, daysData) {
        var defer = $q.defer();

        if (!brandId) {
            throw "Brand not found, got brandId: " + brandId;
        }

        if (!Array.isArray(daysData) || !daysData) {
            throw 'We need actual stats send on the params';
        }

        var payload = {
            "actual_stats": [{
                "days": daysData
            }]
        };

        _protected.request('brands/' + brandId + '/stats', 'PUT', payload)
            .then(function (res) {
                if (res.status == 200 && res.data && res.data.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getUploadedHistoricalDataFiles = function(brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/stats/files', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.checkUploadedFileStatus = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/stats/files/PENDING', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.uploadStatusFile = function (brandId, filePath) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        var params = {
            file_path: filePath
        };

        _protected.request('brands/' + brandId + '/stats/files', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTotalSalesPerWeek = function (enterpriseId, date) {
        var deferred = $q.defer();

        if (!date) {
            deferred.reject({err: "Please send start day of week"});
        } else {
            _protected.request('groups/' + enterpriseId + '/stats/forecast/week', 'GET', {date: date})
                .then(function (data) {
                if (data && data.data && data.data.data && data.data.data.brands && data.status == 200) {
                    deferred.resolve(data.data.data.brands);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });
        }

        return deferred.promise;
    };

    self.copyBrandForecastedStatsFrom = function (brandId, from, to, type) {
        var deferred = $q.defer();

        var params = {};
        params["from_" + type] = from;
        params["to_" + type] = to;

        _protected.request('brands/' + brandId + '/stats/forecast/duplicate', 'POST', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getForecastReplaceHistory = function (brandId, startWeek) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!startWeek) {
            throw "No start week";
        }

        var params = {
            'start_week_date': startWeek
        };

        _protected.request('brands/' + brandId + '/stats/forecast/replace/history', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data && data.status === 200) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getOriginalForecastData = function (brandId, weekStart) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/stats/forecast/original', 'GET', {start_week_date: weekStart})
            .then(function (data) {
                if (data && data.data && data.data.data) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getPendingForecastedStats = async (brandId, params) => {
        const response = await _protected.request(`brands/${brandId}/stats/forecast/pending`, 'GET', params);

        if (response.data.data) {
            return response.data.data;
        }

        throw response;
    }

    self.getForecastedStats = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/stats/forecast', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getActualStats = function (brandId, params) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/stats/actual', 'GET', params)
            .then(function (data) {
                if (data && data.data && data.data.data) {
                    deferred.resolve(data.data.data);
                } else {
                    deferred.reject(data);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getTotalTipsDistribution = async (brandId, fromDate, toDate) => {
        let params = {
            from_date: fromDate,
            to_date: toDate
        };

        let response = await _protected.request(`groups/${brandId}/stats/actual`, "GET", params);
        if (response?.data?.data && response.status === 200) {
            return response.data.data
        }

        throw response;
    }
};